/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import {LanguageCodeType} from '../../../models/localization/language-code-type';

/**
 * Return video asset display name base on: language, hasSub, hasDub and audioConfigurationTypes
 *
 * @param {object} video asset
 */
const GetVideoDisplayName = (video) => {
    const {
        assetComment,
        assetName,
        audioConfigTypes,
        hasDub,
        hasSub,
        textless,
        texted,
        language,
        name: videoName,
    } = video.toJS();

    const videoAssetName = assetComment || videoName || assetName || '';
    const isEnglish = language === 'EN';

    let dubSub = null;
    if (hasSub && hasDub) {
        dubSub = 'Dubbed/Subtitled';
    } else if (hasSub) {
        dubSub = 'Subtitled';
    } else if (hasDub) {
        dubSub = 'Dubbed';
    }

    let languageName = '';
    if (language) {
        languageName = LanguageCodeType.LANGUAGES[language];
    }

    let languageDubSub = '';
    if (languageName && dubSub) {
        languageDubSub = ` (${languageName} ${dubSub || ''})`;
    } else {
        if (languageName && !isEnglish) {
            languageDubSub = ` (${languageName})`;
        } else {
            if (dubSub) {
                languageDubSub = ` (${dubSub})`;
            }
        }
    }

    const audioConfigOrder = ['Split', 'Stereo Mix', '5.1 Mix', 'MONO', 'Mos', 'Sot'];
    const audioConfigTypesData = audioConfigOrder.reduce((audioConfigArray, audioConfigItem) => {
        if ((audioConfigTypes || []).findIndex(audioConfigDataItem => audioConfigDataItem === audioConfigItem) >= 0) {
            audioConfigArray.push(audioConfigItem);
        }
        return audioConfigArray;
    }, []);

    let audioConfigTypesDiplayName = '';
    if (audioConfigTypesData.length) {
        audioConfigTypesDiplayName = ` (${audioConfigTypesData.join('/')})`;
    }

    let result = `${videoAssetName}${languageDubSub}${audioConfigTypesDiplayName}`;
    if (textless) {
        result += ' (Textless)';
    }
    if (texted) {
        result += ' (Texted)';
    }

    return result;
};

export {
    GetVideoDisplayName
};
